import { useMemo } from 'react'

import { ModalType, useModal } from 'src/providers/ModalProvider'

import {
  Action,
  ActionsDropdown
} from 'src/components/molecules/ActionsDropdown'

import { editPlantingPath } from 'src/config/paths'
import { PlantingType, PlantingWorkflowState } from 'src/types/planting'

export type ApplicationActionsProps = {
  planting: PlantingType
  className?: string
}

export const PlantingActions = ({
  className = '',
  planting
}: ApplicationActionsProps) => {
  const { openModal } = useModal()

  const actions = useMemo(() => {
    const plantingActions: Array<Action> = []
    if (planting.WorkflowState === PlantingWorkflowState.Draft) {
      plantingActions.push(
        {
          text: 'Edit report',
          href: editPlantingPath({
            routeParams: {
              applicationId: planting.ApplicationId,
              plantingId: planting.Id,
              projectId: planting.Application?.Project?.Id
            }
          })
        },
        {
          text: 'Delete report',
          onClick: () => {
            openModal(ModalType.DeletePlanting, {
              plantingId: planting.Id
            })
          }
        }
      )
    }
    return plantingActions
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planting.ApplicationId, planting.Id, planting.WorkflowState])

  return actions.length ? (
    <ActionsDropdown
      actions={actions}
      className={className}
      buttonComponentProps={{ variant: 'outline' }}
    >
      Actions
    </ActionsDropdown>
  ) : null
}
